import React from 'react'
import PropTypes from 'prop-types'
import ReactECharts from 'echarts-for-react'

import { Card } from '@mui/material'
import { MONTH } from '../StatisticsUtil'
import { formatMilliers } from 'common/utils/StringUtil'

// Affiche la valeur en label uniquement sur le dernier point (mois en cours)
const withCurrentMonthLabel = (values) => values.map((v, i) => (
    i === values.length - 1 && Number.isFinite(v)
        ? { value: v, label: { show: true, position: 'top', formatter: ({ value }) => formatMilliers(value) } }
        : v
))

const TicketsLine = ({ chartData = [], loading = false }) => {
    const options = {
        title: {
            text: 'Tickets ouverts / résolus et stock',
            left: 'center',
            top: 10,
        },
        grid: {
            top: 50,
            bottom: 70,
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'line' },
            formatter: (params) => {
                const header = params[0]?.axisValue ?? ''
                const lines = params.map(p => `${p.marker}${p.seriesName} : ${Number.isFinite(p.value) ? formatMilliers(p.value) : '-'} tickets`)
                return [header, ...lines].join('<br/>')
            },
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: {
                    show: true,
                    title: 'Télécharger l\'image',
                    name: 'Recette',
                    backgroundColor: 'white',
                    pixelRatio: 2,
                },
            },
            right: '10px',
            top: '10px',
        },
        xAxis: {
            type: 'category',
            data: chartData.map(d => {
                const splitted = d.date.split('-')
                return `${MONTH[parseInt(splitted[0])]} - ${splitted[1]}`
            }),
            axisLabel: { interval: 0, rotate: 40 },
        },
        yAxis: [
            {
                type: 'value',
                name: 'Nombre de ticket',
                nameRotate: 90,
                nameLocation: 'center',
                nameGap: 40,
                axisLabel: { formatter: (v) => formatMilliers(v) },
            },
            {
                type: 'value',
                name: 'Stock',
                nameRotate: 90,
                nameLocation: 'center',
                nameGap: 40,
                position: 'right',
                axisLabel: { formatter: (v) => formatMilliers(v) },
            },
        ],
        legend: {
            left: 'center',
            type: 'scroll',
            width: '90%',
            itemGap: 20,
            bottom: '2%',
        },
        series: [
            {
                name: 'Tickets ouverts',
                type: 'bar',
                data: withCurrentMonthLabel(chartData.map(d => d.nbSubmitted)),
            },
            {
                name: 'Tickets résolus',
                type: 'bar',
                data: withCurrentMonthLabel(chartData.map(d => d.nbSolved)),
            },
            {
                name: 'Créés encore ouverts',
                type: 'line',
                smooth: true,
                itemStyle: { color: '#e74c3c' },
                lineStyle: { color: '#e74c3c' },
                data: withCurrentMonthLabel(chartData.map(d => d.stillOpen)),
            },
            {
                name: 'Stock',
                type: 'line',
                smooth: true,
                yAxisIndex: 1,
                itemStyle: { color: '#f1c40f' },
                lineStyle: { color: '#f1c40f' },
                data: withCurrentMonthLabel(chartData.map(d => d.stock)),
            },
        ],
    }

    return (
        <Card>
            <ReactECharts
                option={options}
                notMerge={true}
                lazyUpdate={true}
                showLoading={loading}
                style={{ height: '300px' }}
            />
        </Card>
    )
}

TicketsLine.propTypes = {
    loading: PropTypes.bool,
    chartData: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.string,
        nbSubmitted: PropTypes.number,
        nbSolved: PropTypes.number,
        stillOpen: PropTypes.number,
        stock: PropTypes.number,
    })),
}

export default TicketsLine
